module.exports = __webpack_public_path__ + "img/avatar.6d9c8c67.jpg";